import api from "@/lib/api";

// Generic chunked upload against the init/chunk/complete pipeline.
// `base` is the endpoint prefix, e.g. `/tasks/<id>/attachments` or `/storage`.
export async function chunkedUpload({ base, file, initBody = {}, onProgress }) {
  const { data: init } = await api.post(`${base}/init`, {
    filename: file.name,
    size: file.size,
    content_type: file.type || "application/octet-stream",
    ...initBody,
  });
  const { upload_id } = init;
  const CH = init.chunk_size || 8 * 1024 * 1024;
  for (let start = 0; start < file.size; start += CH) {
    const chunk = file.slice(start, Math.min(start + CH, file.size));
    await api.put(`${base}/chunk/${upload_id}`, chunk, {
      headers: { "Content-Type": "application/octet-stream" },
    });
    if (onProgress) onProgress(Math.min(99, Math.round((Math.min(start + CH, file.size) / file.size) * 100)));
  }
  const { data } = await api.post(`${base}/complete/${upload_id}`);
  if (onProgress) onProgress(100);
  return data;
}
